import { Observable, Subject, of } from 'rxjs';
import { BaseService } from '../_shared/base.service';
import { PaymentInfo } from './payment-service.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { JWTTokenService } from './jwtToken.service';

const SAVE_INTERVAL =  300000// in ms

export abstract class CUEServiceBase<TFormData, TListData> extends BaseService {

  public saveToLocalStorage: Subject<boolean> = new Subject();
  public saveInterval: number;

  constructor(
    private http: HttpClient, 
    private controllerPath: string,
    jwtTokenService: JWTTokenService) {

    super(http, jwtTokenService);
  }

  public calculatePrice(id: number, model: TFormData, couponCode: string): Observable<PaymentInfo> {
    // Sanitize temp URLs: at this point (price calculation) the user can still back out, so images
    // are not yet uploaded and they have temporary urls which break deserialization on the server.
    Object.keys(model).forEach(k => {
      const val = model[k];
      if (val && val.changingThisBreaksApplicationSecurity) {
        model[k] = '[tempurl]';
      }
    });

    if (id) {
      return this.HttpPost(`${this.controllerPath}/${id}/offer`, model, true, new HttpParams().append('couponCode', couponCode));
    } else {
      return this.HttpPost(`${this.controllerPath}/offer`, model, true, new HttpParams().append('couponCode', couponCode));
    }
  }

  public getById(id: number): Observable<TFormData> {
    return this.CachedHttpGet<TFormData>(`${this.controllerPath}/${id}`);
  }

  delete(id: number): Observable<any> {
    this.RemoveFromCache(this.controllerPath);
    return this.HttpDelete(this.controllerPath, id);
  }

  public regenerate (id: number) : Observable<any> {
      
    this.RemoveFromCache(this.controllerPath);
    return this.HttpPost(`${this.controllerPath}/reactivate/${id}`,null);
  }

  public save(id: number, data: TFormData, couponCode: string, stripeToken: string, expectedAmount: number, notifyCreator: boolean): Observable<any> {
    const params = new HttpParams()
      .append('couponCode', couponCode)
      .append('stripeToken', stripeToken)
      .append('expectedAmount', expectedAmount.toString())
      .append('notifyCreator', notifyCreator.toString());
    this.RemoveFromCache(this.controllerPath);
    if (id) {
      return this.HttpPut(`${this.controllerPath}/${id}`, data, true, params);
    } else {
      return this.HttpPost(`${this.controllerPath}`, data, true, params);
    }
  }

  public getAll(): Observable<TListData[]> {
    return this.CachedHttpGet<TListData[]>(this.controllerPath);
  }

  public abstract getServiceDisplayName(): string;

  public startSaveInterval () {

    this.saveInterval = window.setInterval(
        () => {

            this.saveToLocalStorage.next();
        },
        SAVE_INTERVAL
    );
  }

  public cleanUp() {

    window.clearInterval(this.saveInterval);
  }
}


export interface LiveServiceFormDataBase {
  regenerateAudio: boolean;
  dateCreated: Date;
  serviceFiles: LiveServiceFileCollection;
}

export interface LiveServiceFileCollection {
  files: LiveServiceFile[];
}

export interface LiveServiceFile {
  file: File;
}